import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { comparisonRows } from '../data/sections';
import { BASE_CHECKOUT_URL, KIT_CHECKOUT_URL } from '../data/checkoutLinks';
export function ComparisonTable() {
  return <section id="comparacion" className="border-t border-mp-border bg-mp-dark py-20 md:py-24 scroll-mt-20" data-id="element-55" data-mp="3ida7q37v322s">
      <Container data-id="element-56" data-mp="3mcj29aaq73ze">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-57" data-mp="3md12sj4f84d4">
          <SectionTag tone="white" data-id="element-58" data-mp="38euhs3kklyuv">Comparativa</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-59" data-mp="38gfcpuasrjt9">
            ¿Qué incluye cada versión?
          </h2>
        </div>
        <p className="mt-6 text-center text-xs uppercase tracking-wide text-mp-gray md:hidden" data-id="element-60" data-mp="1wxkwdbhvswqx">
          ← Desliza para ver la tabla completa →
        </p>

        <div className="mt-6 overflow-x-auto rounded-2xl border border-mp-border" data-id="element-61" data-mp="2dwvxc0cv9tvi">
          <table className="w-full min-w-[520px] border-collapse text-left" data-id="element-62" data-mp="29w3m51kfpewl">
            <thead data-id="element-63" data-mp="29y6jk6nx2abc">
              <tr className="bg-mp-card" data-id="element-64" data-mp="2nvbou4ft355j">
                <th className="px-5 py-4 font-heading text-xs uppercase tracking-wide text-mp-gray md:text-sm" data-id="element-65" data-mp="2nweg4dh1j9lz">
                  Incluye
                </th>
                <th className="px-5 py-4 text-center font-heading text-xs uppercase tracking-wide text-mp-white md:text-sm" data-id="element-66" data-mp="2ww1culytrr8p">
                  Base 16,90€
                </th>
                <th className="px-5 py-4 text-center font-heading text-xs uppercase tracking-wide text-mp-lime md:text-sm" data-id="element-67" data-mp="2ssva3oax8i6z">
                  Kit 21,90€
                </th>
              </tr>
            </thead>
            <tbody data-id="element-68" data-mp="3gka9p9bbclej">
              {comparisonRows.map((row, i) => <tr key={row.feature} className={i % 2 === 0 ? 'bg-mp-black/40' : 'bg-transparent'} data-id="element-69" data-mp="3gi650p5lbid7" data-mpi={i}>
                  <td className="border-t border-mp-border px-5 py-3.5 text-sm text-mp-white md:text-[15px]" data-id="element-70" data-mp="3bj2zl3lp7a4p">
                    {row.feature}
                  </td>
                  <td className="border-t border-mp-border px-5 py-3.5 text-center" data-id="element-71" data-mp="3no8mj5kc2tbl">
                    {row.base ? <CheckIcon className="mx-auto h-4 w-4 text-mp-white" strokeWidth={2.5} data-id="element-72" data-mp="3sl8u5kwu044t" /> : <MinusIcon className="mx-auto h-4 w-4 text-mp-gray/50" strokeWidth={2.5} data-id="element-73" data-mp="19pahfitzq8a" />}
                  </td>
                  <td className="border-t border-mp-border px-5 py-3.5 text-center" data-id="element-74" data-mp="a7sto56cgawx">
                    {row.kit ? <CheckIcon className="mx-auto h-4 w-4 text-mp-lime" strokeWidth={2.5} data-id="element-75" data-mp="f8yktykcvq4c" /> : <MinusIcon className="mx-auto h-4 w-4 text-mp-gray/50" strokeWidth={2.5} data-id="element-76" data-mp="k4nrelusm7a5" />}
                  </td>
                </tr>)}
              <tr className="bg-mp-card" data-id="element-77" data-mp="2lywhrzrf9bdr">
                <td className="border-t border-mp-border px-5 py-4 font-heading text-sm uppercase text-mp-white md:text-base" data-id="element-78" data-mp="2eeluluaimc3a">
                  Precio
                </td>
                <td className="border-t border-mp-border px-5 py-4 text-center font-heading text-lg text-mp-white md:text-xl" data-id="element-79" data-mp="29mko6p013fl6">
                  16,90 €
                </td>
                <td className="border-t border-mp-border px-5 py-4 text-center font-heading text-lg text-mp-lime md:text-xl" data-id="element-80" data-mp="1zr0t24tagkxh">
                  21,90 €
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center" data-id="element-81" data-mp="2sciup0o6h0mp">
          <p className="font-heading text-lg uppercase text-mp-white sm:text-xl" data-id="element-82" data-mp="2nehb8emuazap">
            Por solo 5 € más añades las dos herramientas de ejecución.
          </p>

          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-83" data-mp="1c03sfo6y1a1j">
            <CTAButton href={BASE_CHECKOUT_URL} variant="secondary" size="md" fullWidthMobile data-id="element-84" data-mp="1710lfy7ektqx">
              Quiero la versión base — 16,90 €
            </CTAButton>
            <CTAButton href={KIT_CHECKOUT_URL} size="lg" showArrow fullWidthMobile data-id="element-85" data-mp="2vtmzls7zh240">
              Quiero todo por 21,90 €
            </CTAButton>
          </div>
          <GuaranteeLine className="mt-4" data-id="element-86" data-mp="2lxth7s7l2eeb" />
        </div>
      </Container>
    </section>;
}